// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"210":"ba511c14cc3082a5","7354":"5564d7510a047027"}[chunkId] + ".js";
};